import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MyMap = ({ setMap }) => {
  const map = useMap();

  useEffect(() => {
    setMap(map);
  }, []);

  return null;
};
export default MyMap;
